import { createReducer, on } from '@ngrx/store';
import { createMergedReducer } from '../../ngrx-helpers/adapters/utils';
import { notificationReceiptLoadAdapter } from './notification-receipt.adapter';
import {
  CountNotificationReceiptAction,
  CountNotificationReceiptErroredAction,
  CountNotificationReceiptSucceededAction,
  MarkAllNotificationReceiptsAction,
  MarkAllNotificationReceiptsErroredAction,
  MarkAllNotificationReceiptsSucceededAction,
  MenuClosedNotificationReceiptAction,
  MenuOpenedNotificationReceiptAction,
} from './notification-receipt.actions';
import { NotificationState, ViewNotificationReceipt } from 'studio-components';
import { LoadWithPaginationState } from '../../ngrx-helpers/adapters/load-with-pagination/reducer';

export interface CountState {
  count: number;
  countState: NotificationState | null;
  countError: Error | null;
  isLoadingCount: boolean;
}

export const countInitialState: CountState = {
  count: 0,
  countState: null,
  countError: null,
  isLoadingCount: false,
};

const notificationCountReducer = createReducer(
  countInitialState,
  on(CountNotificationReceiptAction, (state, action) => ({
    ...state,
    countState: action.state,
    isLoadingCount: true,
    countError: null,
  })),
  on(CountNotificationReceiptSucceededAction, (state, { count }) => ({
    ...state,
    count,
    isLoadingCount: false,
  })),
  on(CountNotificationReceiptErroredAction, (state, { error }) => ({
    ...state,
    count: 0,
    countError: error,
    isLoadingCount: false,
  })),
);

export interface MarkAllState {
  markAllError: Error | null;
  markAllState: NotificationState | null;
  isLoadingMarkAll: boolean;
}

export const markAllInitialState: MarkAllState = {
  markAllError: null,
  markAllState: null,
  isLoadingMarkAll: false,
};

const notificationMarkAllReducer = createReducer(
  markAllInitialState,
  on(MarkAllNotificationReceiptsAction, (state, action) => ({
    ...state,
    markAllError: null,
    markAllState: action.state,
    isLoadingMarkAll: true,
  })),
  on(MarkAllNotificationReceiptsSucceededAction, (state) => ({
    ...state,
    isLoadingMarkAll: false,
  })),
  on(MarkAllNotificationReceiptsErroredAction, (state, { error }) => ({
    ...state,
    markAllError: error,
    isLoadingMarkAll: false,
  })),
);

export interface MenuNotificationReceiptState {
  isOpen: boolean;
}

export const menuNotificationReceiptInitialState: MenuNotificationReceiptState = {
  isOpen: false,
};

const notificationReceiptMenuReducer = createReducer(
  menuNotificationReceiptInitialState,
  on(MenuOpenedNotificationReceiptAction, (state) => ({ ...state, isOpen: true })),
  on(MenuClosedNotificationReceiptAction, (state) => ({ ...state, isOpen: false })),
);

export interface NotificationReceiptState
  extends CountState,
    MarkAllState,
    MenuNotificationReceiptState,
    LoadWithPaginationState<ViewNotificationReceipt> {}

export const notificationReceiptReducer = createMergedReducer(
  notificationReceiptLoadAdapter.getReducer(),
  notificationCountReducer,
  notificationMarkAllReducer,
  notificationReceiptMenuReducer,
);
